import React from "react";
import styled from "styled-components";

import Icon from "./icon";

const Container = styled.div`
	font-family: Roboto;
	display: flex;
	align-items: center;
	background-color: ${(props) => (props.checked ? "#004ECC" : "#e4e5e7")};
	padding: 0 16px;
	border-radius: 10px;
	margin-bottom: 1rem;
	height: 50px;
	cursor: pointer;
	border: ${(props) => (props.$showtag == "true" ? "1px solid #004ECC" : "none")};

	.rr-tag-div {
		display: flex;
		flex-direction: row;
		position: relative;
		z-index: 50;
		margin-top: -1.5rem;
	}
	.rr-tag {
		font-size: 12px;
		line-height: 16px;
		background-color: ${(props) => (props.checked ? "white" : "#004ECC")};
		color: ${(props) => (props.checked ? "#004ECC" : "white")};
		padding: 2px 6px;
		border-radius: 12px;
		position: static;
	}

	.rr-check-svg {
		display: flex;
		flex-direction: column;
		justify-content: center;
		height: 100%;
	}

	.rr-check-text {
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 100%;
		color: ${(props) => (props.checked ? "#ffffff" : "#18191b")};
		height: 100%;
		line-height: 16px;
	}
`;

function Check({ checked, onClick, label, sublabel = null, showtag = "false", ...props }) {
	return (
		<Container {...props} checked={checked} $showtag={showtag} onClick={onClick}>
			<div className="rr-check-svg">
				<Icon viewBox="0 0 448 512" size={18} cursor="pointer" icon={checked ? "square" : "solidSquare"} stroke="#ffffff" color="#ffffff" />
			</div>

			<div className="rr-check-text">
				<span style={{ fontWeight: sublabel ? "600" : "500" }}>{label}</span>
				{sublabel && <span style={{ fontSize: "14px", marginTop: "4px" }}>{sublabel}</span>}
			</div>

			{showtag == "true" && (
				<div className="rr-tag-div">
					<div className="rr-tag">RECOMMENDED</div>
				</div>
			)}
		</Container>
	);
}

export default Check;
